module.exports = __webpack_public_path__ + "img/wedding-07.89d27033.jpg";